const IntegrationLogSectionEmpty = () => {
  return <div className="hidden lg:flex w-90 ml-6 min-h-full"></div>
}

export default IntegrationLogSectionEmpty
